import React from 'react'
import {
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
    Tooltip,
} from '@diversioteam/diversio-ds'

import { useCopyToClipboard } from 'hooks/useCopyToClipboard'
import img from 'assets/images/pulseSurveys/experience-dialog.svg'

import * as S from './../dialog.styles'

export const ExperienceDialog = (props: DialogProps) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard()

    const handleClose = () => {
        if (props.onClose) {
            props.onClose({}, 'backdropClick')
        }
    }

    return (
        <S.DialogWrapper hideBackdrop={false} {...props}>
            <DialogTitle>
                <img src={img} alt="" />
                Experience・Survey
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <p>
                        Help your organization understand how inclusive and supportive your workplace culture truly is.
                    </p>

                    <p>Why it matters:</p>
                    <ul>
                        <li>Identify gaps in employee experience</li>
                        <li>Improve retention and engagement</li>
                        <li>Get actionable insights to build a better culture</li>
                    </ul>

                    <p>
                        Note: People Representation survey must be completed first.
                        <br />
                        <strong>Contact us or reach out directly to your CSM to get started.</strong>
                    </p>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button color="secondaryLight" onClick={handleClose} fullWidth>
                    Cancel
                </Button>

                <Tooltip
                    title="Copied!"
                    variant="light"
                    size="medium"
                    open={isCopied}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                >
                    <Button onClick={() => copyToClipboard('hello@diversio.com')} fullWidth>
                        Copy: hello@diversio.com
                    </Button>
                </Tooltip>
            </DialogActions>
        </S.DialogWrapper>
    )
}
